(function () {
	'use strict';
	angular.module('qbePortal')
		.component('qbListAccordion', {
			templateUrl: '/ngviews/components/qbListAccordion.html',
			controllerAs: 'vm',
			transclude: true,
			bindings: {
				includedList : '<',
				excludedList : '<',
			}
		})
		.directive('onRepeatEnd', function ($timeout) {
			return function (scope, element, attrs) {
				if (scope.$last) {
					$timeout(function () {
						QBE.listAccordion.init();
					});
				}
			}
		});
})();
